<script setup>
import * as echarts from 'echarts';
import { onMounted } from 'vue';
import XuTitle from './XuTitle.vue'
import { getRoomArea } from "@/api/common";
import { useRouter } from "vue-router";
const { currentRoute } = useRouter();
const router = currentRoute.value
const CubeLeft = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0,
  },
  buildPath: function (ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c0 = [shape.x, shape.y];
    const c1 = [shape.x - 12, shape.y - 12];
    const c2 = [xAxisPoint[0] - 12, xAxisPoint[1] - 12];
    const c3 = [xAxisPoint[0], xAxisPoint[1]];
    ctx
      .moveTo(c0[0], c0[1])
      .lineTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .closePath();
  },
});
const CubeRight = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0,
  },
  buildPath: function (ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x, shape.y];
    const c2 = [xAxisPoint[0], xAxisPoint[1]];
    const c3 = [xAxisPoint[0] + 12, xAxisPoint[1] - 6];
    const c4 = [shape.x + 12, shape.y - 6];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  },
});
const CubeTop = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0,
  },
  buildPath: function (ctx, shape) {
    const c1 = [shape.x, shape.y];
    const c2 = [shape.x + 12, shape.y - 6];
    const c3 = [shape.x, shape.y - 18];
    const c4 = [shape.x - 12, shape.y - 12];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  },
});
echarts.graphic.registerShape("CubeLeft", CubeLeft);
echarts.graphic.registerShape("CubeRight", CubeRight);
echarts.graphic.registerShape("CubeTop", CubeTop);
let myChart = null;
let option = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      lineStyle: {
        color: "#57617B",
      },
    },
  },
  grid: {
    top: 20,
    left: 0,
    right: 0,
    bottom: 0,
    containLabel: true,
  },
  xAxis: {
    type: "category",
    // boundaryGap: false,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      rotate: 45,
      color: "#fff"
    },
    data: []
  },
  dataZoom: [
    //滑动条
    {
      show: false, //是否显示滑动条，不影响使用
      type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
      startValue: 0, // 从头开始。
      endValue: 6, // 一次性展示6个。
    },
  ],
  yAxis: [
    {
      type: "value",
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#90a0ae",
        },
      },
      splitLine: {
        lineStyle: {
          color: "rgba(0, 136, 212, 0.3)",
        },
      },
    },
  ],
  series: {
    type: "custom",
    renderItem: (params, api) => {
      const location = api.coord([api.value(0), api.value(1)]);
      return {
        type: "group",
        children: [
          {
            type: "CubeLeft",
            shape: {
              api,
              xValue: api.value(0),
              yValue: api.value(1),
              x: location[0],
              y: location[1],
              xAxisPoint: api.coord([api.value(0), 0]),
            },
            style: {
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00fcfc",
                },
                {
                  offset: 1,
                  color: "#49BEE5",
                },
              ]),
            },
          },
          {
            type: "CubeRight",
            shape: {
              api,
              xValue: api.value(0),
              yValue: api.value(1),
              x: location[0],
              y: location[1],
              xAxisPoint: api.coord([api.value(0), 0]),
            },
            style: {
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00fcfc",
                },
                {
                  offset: 1,
                  color: "#49BEE5",
                },
              ]),
            },
          },
          {
            type: "CubeTop",
            shape: {
              api,
              xValue: api.value(0),
              yValue: api.value(1),
              x: location[0],
              y: location[1],
              xAxisPoint: api.coord([api.value(0), 0]),
            },
            style: {
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00fcfc",
                },
                {
                  offset: 1,
                  color: "#49BEE5",
                },
              ]),
            },
          },
        ],
      };
    },
    data: []
  }
};
onMounted(() => {
  getRoomArea(router.query.projectId).then(res => {
    if (res.success) {
      let data = res.data;
      option.xAxis.data = data.xaxis;
      option.series.data = data.series;
      myChart = echarts.init(document.getElementById("barChart"));
      myChart.setOption(option, true);
      //通过定时器的方式刷新，改变statrValue，endValue
      setInterval(() => {
        // 每次向后滚动一个，最后一个从头开始。
        if (option.dataZoom[0].endValue == data.xaxis.length) {
          option.dataZoom[0].endValue = 6;
          option.dataZoom[0].startValue = 0;
        } else {
          option.dataZoom[0].endValue = option.dataZoom[0].endValue + 1;
          option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1;
        }
        myChart.setOption(option);
      }, 3000);
    }
  })
})
</script>
<template>
  <XuTitle title="冷间面积分布" subTitle="COLD ROOM AREA"></XuTitle>
  <div id="barChart" class="bar-chart-box"></div>
</template>
<style lang="scss" scoped>
.bar-chart-box {
  width: 100%;
  height: 260px;
}
</style>